import * as React from "react";
import clockIcon from '../assets/images/clock.svg';
import { useState, useEffect } from "react";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { getActionType, getHistoryActionLogs } from "../services/commonService";
import { formatDateTime } from "../utils/validate";
import { HistoryDespCard } from "../pages/historyTab/HistoryDespCard";

// ── DataGrid columns for detail rows ──────────────────────
const detailColumns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "creationDateTime", headerName: "Date/Time", flex: 1 },
    { field: "performedBy", headerName: "Performed By", width: 130 },
    { field: "key", headerName: "key", flex: 2 },
    {
        field: "actionStatus", headerName: "Status", width: 90,
        renderCell: ({ value }) => (
            <span style={{
                padding: "2px 10px", borderRadius: "12px",
                fontSize: "12px", fontWeight: 500,
                background: value ? "#EAF3DE" : "#FCEBEB",
                color: value ? "#27500A" : "#791F1F",
            }}>
                {value ? "Success" : "Failed"}
            </span>
        ),
    },
];

const CustomLoadingOverlay = () => (
    <GridOverlay><CircularProgress size={28} /></GridOverlay>
);

export const ActionLogItem = ({ actionLogsList, isLoading, viewDetailShow, setViewDetailShow, estateId }) => {

    const [actionTypeList, setActionTypeList] = useState([]);

    // Per-row state: { [item.id]: { expanded, detailRows, isLoadingDetail } }
    const [rowStates, setRowStates] = useState({});

    const handlerViewDetailShow = async (itemId) => {
        // If already fetched, just toggle open
        if (rowStates[itemId]?.detailRows?.length > 0) {
            setRowStates(prev => ({ ...prev, [itemId]: { ...prev[itemId], expanded: true } }));
            return;
        }

        // Set loading
        setRowStates(prev => ({ ...prev, [itemId]: { expanded: true, detailRows: [], isLoadingDetail: true } }));

        const actionLogs = await getHistoryActionLogs({ estateId, actionLogId: itemId });

        // Map identity from metadata for description column
        const rows = (actionLogs.data ?? []).map(r => ({
            ...r,
            key: (() => {
                try { return JSON.parse(r.metadata ?? "{}").key ?? "N/A"; }
                catch { return "N/A"; }
            })(),
        }));

        console.log(rows);

        setRowStates(prev => ({ ...prev, [itemId]: { expanded: true, detailRows: rows, isLoadingDetail: false } }));
    };

    const handlerViewDetailClose = (itemId) => {
        setRowStates(prev => ({ ...prev, [itemId]: { ...prev[itemId], expanded: false } }));
    };

    useEffect(() => {
        const getActionLogs = async () => {
            const actionLogs = await getActionType();
            setActionTypeList(actionLogs.data);
        }
        getActionLogs();
    }, []);

    console.log(actionLogsList);

    return (
        <>
            <div>
                {
                    isLoading ?
                        <p>Loading...</p>
                        : actionLogsList.length === 0 ?
                            <p className="text-center pt-5">No records found !</p>
                            : actionLogsList.map((item, index) => {
                                let deSerilize = JSON.parse(item.metadata);
                                const performedBy = item.performedBy ?? item.agentName ?? "N/A";

                                // Per-row expand state
                                const rowState = rowStates[item.id] ?? {};
                                const expanded = rowState.expanded ?? false;
                                const detailRows = rowState.detailRows ?? [];
                                const isLoadingDetail = rowState.isLoadingDetail ?? false;

                                return (
                                    <div key={item.id} className={`action-log-container p-3 mb-3 ${item.actionStatus ? "" : "bg-error"}`}>
                                        <div>
                                            <h6 className="mb-2 d-flex"> <img src={clockIcon} className="me-1" width="20" alt="clock icon" />{formatDateTime(item.creationDateTime)}</h6>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                {/*<p className="mb-0 log-label action-log-btn-padd"> {actionTypeList[item.actionId]?.actionName}</p>*/}
                                                <p className="mb-0 log-label action-log-btn-padd">
                                                    {actionTypeList.find(a => a.id === item.actionId)?.actionName}
                                                </p>
                                                <p className="mb-0 site-btn-red action-log-btn-padd">Sync with Whise CRM: {item.syncWithWhise ? "True" : "False"}</p>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <HistoryDespCard
                                                    item={item}
                                                />
                                                <div>
                                                    {/* Per-row toggle button */}
                                                    <button
                                                        className={`${item.actionId == 4 || item.actionId == 1? "d-none" : "mb-0 action-log-btn-padd site-btn"} `}
                                                        onClick={() => expanded ? handlerViewDetailClose(item.id) : handlerViewDetailShow(item.id)}
                                                        disabled={isLoadingDetail}
                                                    >
                                                        {isLoadingDetail ? "Loading..." : expanded ? "Less Details" : "View Details"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ✅ DataGrid — only renders when this row is expanded */}
                                        {expanded && (
                                            <div className="mt-3">
                                                <DataGrid
                                                    rows={detailRows}
                                                    columns={detailColumns}
                                                    pageSizeOptions={[5, 10, 25]}
                                                    initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
                                                    disableRowSelectionOnClick
                                                    getRowClassName={({ indexRelativeToCurrentPage: i }) =>
                                                        i % 2 === 0 ? "even-row-waiting-grid" : "odd-row-waiting-grid"
                                                    }
                                                    loading={isLoadingDetail}
                                                    disableColumnMenu
                                                    slots={{ loadingOverlay: CustomLoadingOverlay }}
                                                    sx={{ height: 300, width: "100%" }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )
                            })
                }

            </div>
        </>
    )
}
